// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d5db05f1","455":"c8cb57cb"}[chunkId] + ".chunk.js";
};